import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, Typography } from '@material-ui/core';
import merge from 'lodash/merge';
import { useDrawerContext } from '../../../context';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        color: theme.palette.text.primary,
    },
    titleWrapper: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    caption: {
        padding: theme.spacing(0, 4, 0, 0),
    },
}));
export const DrawerTitle = (props) => {
    const { headerProps: contextProps } = useDrawerContext();
    // Merge titleProps (contextProps) with props, giving precedence to props
    const mergedProps = merge({}, contextProps, props);
    const { title, caption, titleProps } = mergedProps;
    const classes = useStyles();
    return (_jsxs("div", { className: classes.titleWrapper, children: [_jsx(Typography, { className: classes.root, "data-testid": 'drawer-title', id: 'drawer-title', variant: 'h3', ...titleProps, children: title }), _jsx(Typography, { className: classes.caption, color: 'textSecondary', "data-testid": 'drawer-caption', id: 'drawer-caption', variant: 'caption', children: caption })] }));
};
